class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const startDate = this.getAttribute("start-date");
    const startTime = this.getAttribute("start-time");
    const endDate = this.getAttribute("end-date");
    const endTime = this.getAttribute("end-time");

    const startMessage = this.getAttribute("start-message");
    const endMessage = this.getAttribute("end-message");
    const completedMessage = this.getAttribute("completed-message");
    const hideAfterEnd = this.getAttribute("hide-after-end") === "true";

    let timerElement = this.querySelector(".custom-media-timer");
    if (!timerElement) {
      timerElement = document.createElement("div");
      timerElement.className = "custom-media-timer";
      this.appendChild(timerElement);
    }

    this.startCountdown(
      startDate,
      startTime,
      endDate,
      endTime,
      timerElement,
      startMessage,
      endMessage,
      completedMessage,
      hideAfterEnd
    );
  }

  startCountdown(startDate, startTime, endDate, endTime, timerElement, startMessage, endMessage, completedMessage, hideAfterEnd) {
     // Convert the start date and time into a timestamp (milliseconds since Unix epoch)
    const start = new Date(`${startDate}T${startTime}`).getTime();
    const end = new Date(`${endDate}T${endTime}`).getTime();

  // Function to update the countdown timer at regular intervals
  const updateTimer = () => {
    const now = new Date().getTime();
  
    let distance, message;
    if (now < start) {
      distance = start - now;
      message = startMessage;
    } else if (now >= start && now < end) {
      distance = end - now;
      message = endMessage;
    } else {
      clearInterval(this.timerInterval);
  
      // Hide the timer section if the hideAfterEnd setting is enabled
      if (hideAfterEnd) {
        this.closest("section").classList.add("hidden");
      } else {
        timerElement.textContent = completedMessage;
      }
      return;
    }
  
    // Calculate days, hours, minutes, and seconds from the remaining time
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    // Determine whether to display "day" or "days"
    const dayText = days === 1 ? "Day" : "Days";
  
    // Build the timer text, skipping days if they are 0
    const timerText = `${message} ` +
      (days > 0 ? `${days} ${dayText} : ` : "") +
      `${hours}H : ${minutes}M : ${seconds}S`;
  
    timerElement.textContent = timerText;
  };
    this.timerInterval = setInterval(updateTimer, 1000);
    updateTimer();
  }

  disconnectedCallback() {
    clearInterval(this.timerInterval);
  }
}

customElements.define("countdown-timer", CountdownTimer);
